const TranslationKeys = {
  CHACK_HASH_CODE: 'CHACK_HASH_CODE',
  ABOUT_HASH_CODE: 'ABOUT_HASH_CODE',
  ROUND_HASH_CODE: 'PROVABLY_FAIRNESS',
  CHECK: 'CHECK',
  resultId: 'ROUND_ID',
  KEY: 'KEY',
  SALT: 'SALT',
  BONUS: 'BONUS',
  NEXT_STEP: 'NEXT_STEP',
  POINT: 'POINT',
  HASH_CODE: 'HASH_CODE',
  FAIRNESS_MODAL_TITLE: 'PROVABLY_FAIRNESS',
  HELP: 'HELP',
  lobby: 'LOBBY',
  About: 'ABOUT',
  Result: 'RESULT',
  FairnessModalTitle: 'FAIRNESS',
  BetTypes: 'BET_TYPES',
  game: 'GAME',
  bets: 'BETS',
  STATISTICS: 'STATISTICS',
  results: 'RESULTS',
  ok: 'OK',
  BonusIsland: 'BONUS_ISLAND',
  pleaseWait: 'PLEASE_WAIT',
  connecting: 'CONNECTING',
  autoBet: 'AUTO_BET',
  betsAreClosing: 'BETS_ARE_CLOSING',
  placeYourBets: 'PLACE_YOUR_BETS',
  betsAreClosed: 'BETS_ARE_CLOSED',
  youWin: 'YOU_WIN',
  provablyFairness: 'PROVABLY_FAIRNESS',
  INFO: 'INFO',
  Rtp: 'RTP',
  ReBet: 'REBET',
  CancelationMessage1: 'CANCELATION_MESSAGE_1',
  MalfunctionMessage2: 'MALFUNCTION_MESSAGE_2',
  BONUS_ISLAND_HOVER_MESSAGE_2: 'BONUS_ISLAND_HOVER_MESSAGE_2',
  BONUS_ISLAND_HOVER_MESSAGE_1: 'BONUS_ISLAND_HOVER_MESSAGE_2',
  RoundId: 'ROUND_ID',
};

export { TranslationKeys as TKeys };
